import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/pocetna.css";
import Header from "./header.js";
import Footer from "./footer.js";
import DvoranaSlika from "./dvoranaSlika.js";
import { FormatiraniTekst, tekstBezOznaka } from "./tekst.js";
import { spojiDane } from "./dvoraneData.js";
import { useSEO } from "./seo.js";

const naTipku = (akcija) => (e) => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    akcija();
  }
};

/*
 * "ekipa" je popis ekipa koje trener vodi, npr. "1.-4. razred, OS Lucko".
 * Dok je prazno, redak se na kartici uopce ne prikazuje - upisi tekst i
 * pojavit ce se sam.
 */
const treneri = [
  {
    inicijali: "F.P.",
    ime: "Fran Peterlin",
    uloga: "Voditelj",
    ekipa: "",
  },
  {
    inicijali: "H.Z.",
    ime: "Hrvoje Zelenika",
    uloga: "Voditelj",
    ekipa: "",
  },
  {
    inicijali: "D.B.",
    ime: "Domagoj Babok",
    uloga: "Trener",
    ekipa: "",
  },
];

function Pocetna({ obavijesti, loading, dvorane, loadingDvorane }) {
  const navigate = useNavigate();
  const [selectedObavijest, setSelectedObavijest] = useState(null);

  // Pocetna se u pregledniku vidi kao "/pocetna", ali se indeksira kao "/".
  useSEO({
    naslov: "OK Virtus - odbojkaški klub | Zagreb, Klinča Sela, Jastrebarsko",
    opis: "Odbojkaški klub Virtus - škola odbojke za djecu od 1. do 8. razreda u Zagrebu, Lučkom, Klinča Selima i Jastrebarskom. Termini treninga, upisi i kampovi.",
    putanja: "/",
  });

  const handleDvoraneBtnClick = () => navigate("/dvorane");
  const handleKampoviBtnClick = () =>
    window.open("https://volleyandfun.com/", "_blank", "noopener,noreferrer");
  const handleGalerijaBtnClick = () => navigate("/galerija");
  const handleObavijestiBtnClick = () => navigate("/obavijesti");

  useEffect(() => {
    if (!selectedObavijest) return;

    const zatvoriNaEscape = (e) => {
      if (e.key === "Escape") setSelectedObavijest(null);
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", zatvoriNaEscape);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", zatvoriNaEscape);
    };
  }, [selectedObavijest]);

  return (
    <div className="pocetna-container">
      <Header />

      <div className="container">
        <main>
          <section id="onama">
            <div className="hero-content">
              <h2>O nama</h2>
              <p>
                Dobrodošli u Odbojkaški klub Virtus - mjesto gdje ljubav prema
                odbojci pretvaramo u timski duh i sportske uspjehe!
              </p>
              <br />
              {/*
                Puni opis je na mobitelu predug za citanje, pa se - jednako kao
                naslov kluba u headeru - CSS-om zamjenjuje kracom verzijom.
                Oba teksta uvijek ostaju u HTML-u, mijenja se samo koji je
                vidljiv, tako da trazilice procitaju i onaj sakriveni.
              */}
              <p className="onama-puni">
                Odbojkaški klub Virtus osnovan je 2025. godine s jasnom vizijom
                – stvoriti okruženje u kojem će se znanje, iskustvo i ljubav
                prema odbojci prenositi na nove generacije sportaša. Naziv
                Virtus dolazi iz latinskog jezika i označava vrlinu, hrabrost i
                snagu. Upravo te vrijednosti predstavljaju temelj našeg rada,
                kako na terenu, tako i izvan njega. Klub su osnovali još uvijek
                aktivni odbojkaši vođeni željom da svoje dugogodišnje iskustvo i
                stečeno znanje prenesu mladim igračima te da i nakon igračke
                karijere ostanu dio sporta koji je obilježio njihove živote.
                Vjerujemo da se uspješni sportaši ne stvaraju samo kroz trening
                i natjecanja, već i kroz razvoj karaktera, međusobnog
                poštovanja, timskog duha i sportskih vrijednosti. Naš cilj je
                pružiti kvalitetan stručni rad, potaknuti ljubav prema odbojci i
                omogućiti svakom članu da razvije svoj puni sportski i osobni
                potencijal.
              </p>
              <p className="onama-kratki">
                Odbojkaški klub Virtus osnovan je 2025. godine, a ime nosi po
                latinskoj riječi za vrlinu, hrabrost i snagu. Osnovali su ga
                aktivni odbojkaši koji svoje iskustvo prenose na mlade igrače,
                uz jednak naglasak na sportski razvoj i na timski duh,
                poštovanje i karakter.
              </p>
            </div>
          </section>

          <section id="dvorane">
            <h2
              className="clickable-title"
              onClick={handleDvoraneBtnClick}
              onKeyDown={naTipku(handleDvoraneBtnClick)}
              role="link"
              tabIndex={0}
            >
              Dvorane
            </h2>

            <p>
              Napravite prvi korak prema terenu i pogledajte dvorane u kojima
              treniramo!
            </p>

            <div className="dvorane-preview-grid">
              {loadingDvorane ? (
                <p>Učitavanje dvorana...</p>
              ) : dvorane.length > 0 ? (
                dvorane.slice(0, 4).map((dvorana) => (
                  <div
                    key={dvorana.id}
                    className="news-card"
                    onClick={handleDvoraneBtnClick}
                    onKeyDown={naTipku(handleDvoraneBtnClick)}
                    role="button"
                    tabIndex={0}
                  >
                    <div className="news-image">
                      <DvoranaSlika src={dvorana.slika} alt={dvorana.naziv} />
                    </div>

                    <div className="news-content">
                      <h3>
                        {dvorana.naziv.split(" | ")[0]}
                        {dvorana.naziv.includes(" | ") && (
                          <span className="dvorana-kvart">
                            ({dvorana.naziv.split(" | ")[1]})
                          </span>
                        )}
                      </h3>

                      <ul>
                        {dvorana.termini.map((grupa, index) => (
                          <li key={index}>
                            {grupa.kategorija && (
                              <span className="termin-kategorija">
                                {grupa.kategorija}
                              </span>
                            )}
                            {grupa.stavke.map((stavka, i) => (
                              <div key={i} className="termin-red">
                                <span className="termin-dani">
                                  {spojiDane(stavka.dani)}
                                </span>
                                <span className="termin-vrijeme">
                                  {stavka.vrijeme}
                                </span>
                              </div>
                            ))}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))
              ) : (
                <p>Trenutno nema podataka o dvoranama.</p>
              )}
            </div>

            <button
              type="button"
              className="gumb-vise"
              onClick={handleDvoraneBtnClick}
            >
              Više dvorana
            </button>
          </section>

          {/*
            Cijeli odjeljak vodi u galeriju da na mobitelu proradi dodir bilo
            gdje po njemu, ne samo po naslovu. Tipkovnicom se i dalje ide
            preko naslova, koji ostaje link - zato odjeljak nema tabIndex ni
            role, da se ista meta ne pojavi dvaput u redoslijedu fokusa.
          */}
          <section
            id="galerija"
            className="sekcija-klikabilna"
            onClick={handleGalerijaBtnClick}
          >
            <div className="hero-content">
              <h2
                className="clickable-title"
                onClick={(e) => {
                  // bez ovoga bi klik po naslovu okinuo i klik na odjeljak
                  e.stopPropagation();
                  handleGalerijaBtnClick();
                }}
                onKeyDown={naTipku(handleGalerijaBtnClick)}
                role="link"
                tabIndex={0}
              >
                Fotogalerija
              </h2>
              <p>
                Zavirite u našu fotogaleriju i osjetite dio atmosfere s
                treninga!
              </p>
            </div>
          </section>

          <section id="obavijesti">
            <h2
              className="clickable-title"
              onClick={handleObavijestiBtnClick}
              onKeyDown={naTipku(handleObavijestiBtnClick)}
              role="link"
              tabIndex={0}
            >
              Obavijesti
            </h2>
            <div className="news-grid">
              {loading ? (
                <p>Učitavanje obavijesti...</p>
              ) : obavijesti.length > 0 ? (
                obavijesti.slice(0, 3).map((n, index) => (
                  <div
                    key={index}
                    className="news-card"
                    onClick={() => setSelectedObavijest(n)}
                    onKeyDown={naTipku(() => setSelectedObavijest(n))}
                    role="button"
                    tabIndex={0}
                  >
                    {n.slika && (
                      <div className="news-image">
                        <img
                          src={n.slika}
                          alt={n.naslov}
                          referrerPolicy="no-referrer"
                          loading="lazy"
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      </div>
                    )}
                    <div className="news-content">
                      <span className="news-date">{n.datum}</span>
                      <h3>{n.naslov}</h3>
                      <p className="line-clamp">{tekstBezOznaka(n.tekst)}</p>
                    </div>
                  </div>
                ))
              ) : (
                <p>Trenutno nema novih obavijesti.</p>
              )}
            </div>

            <button
              type="button"
              className="gumb-vise"
              onClick={handleObavijestiBtnClick}
            >
              Više obavijesti
            </button>
          </section>

          <section id="kampovi">
            <div className="kampovi-grid">
              <div className="kamp-polje kamp-slika-1">
                <img
                  src="/photos/Volley_and_fun/drustvena_igra_1.webp"
                  alt="Volley and Fun kamp"
                  loading="lazy"
                />
              </div>

              <div className="kamp-polje kamp-slika-2">
                <img
                  src="/photos/Volley_and_fun/majca_2.webp"
                  alt="Volley and Fun kamp"
                  loading="lazy"
                />
              </div>

              <div className="kamp-polje kamp-slika-3">
                <img
                  src="/photos/Volley_and_fun/odbojkaska_lopta_1.webp"
                  alt="Volley and Fun kamp"
                  loading="lazy"
                />
              </div>

              <div className="kamp-tekst">
                <h2
                  className="clickable-title"
                  onClick={handleKampoviBtnClick}
                  onKeyDown={naTipku(handleKampoviBtnClick)}
                  role="link"
                  tabIndex={0}
                >
                  Volley&amp;Fun
                </h2>

                <p>
                  Organiziramo odbojkaške kampove za djecu i mlade koje vode
                  vrhunski treneri, odbojkaški reprezentativci i igrači
                  Superlige. Ako je vaše dijete odbojkaški početnik ili želi
                  unaprijediti svoju odbojkašku igru, ovaj kamp je idealan za
                  njega/nju. Iskoristite ovu jedinstvenu priliku i omogućite
                  svom djetetu nezaboravan tjedan pun odbojke, zanimljivih
                  igara, zabave i bogatog druženja.
                </p>

                <p className="kamp-poveznica">
                  Stranicu kampa možete pogledati{" "}
                  <a
                    href="https://volleyandfun.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ovdje
                  </a>
                  .
                </p>
              </div>

              <div className="kamp-polje kamp-slika-4">
                <img
                  src="/photos/Volley_and_fun/servis_1.webp"
                  alt="Volley and Fun kamp"
                  loading="lazy"
                />
              </div>

              <div className="kamp-polje kamp-slika-5">
                <img
                  src="/photos/Volley_and_fun/igra_2.webp"
                  alt="Volley and Fun kamp"
                  loading="lazy"
                />
              </div>

              <div className="kamp-polje kamp-slika-6">
                <img
                  src="/photos/Volley_and_fun/treneri_1.webp"
                  alt="Volley and Fun kamp"
                />
              </div>
            </div>
          </section>

          <section id="treneri">
            <h2>Naš tim</h2>
            <p>
              Upoznajte stručni tim koji stoji iza svakog treninga - treneri s
              licencama i dugogodišnjim igračkim iskustvom.
            </p>
            <div className="treneri-grid">
              {treneri.map((trener, index) => (
                <div key={index} className="trener-card">
                  <div className="trener-avatar">{trener.inicijali}</div>
                  <h3>{trener.ime}</h3>
                  <span className="trener-uloga">{trener.uloga}</span>
                  {trener.ekipa && <p>{trener.ekipa}</p>}
                </div>
              ))}
            </div>
          </section>
        </main>

        <Footer />
      </div>

      {selectedObavijest && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedObavijest(null)}
          role="dialog"
          aria-modal="true"
          aria-label={selectedObavijest.naslov}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setSelectedObavijest(null)}
              aria-label="Zatvori obavijest"
            >
              &times;
            </button>

            {selectedObavijest.slika && (
              <img
                src={selectedObavijest.slika}
                alt={selectedObavijest.naslov}
                className="modal-img"
                referrerPolicy="no-referrer"
              />
            )}

            <div className="modal-body">
              <span className="news-date">{selectedObavijest.datum}</span>
              <h2>{selectedObavijest.naslov}</h2>
              <p>
                <FormatiraniTekst tekst={selectedObavijest.tekst} />
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Pocetna;
